import { type FC } from 'react';
import styled from 'styled-components';

import { InternalLink } from '@/components/InternalLink';

interface Props {
  to: string;
  direction: 'left' | 'right';
}

export const NavigationPad: FC<Props> = ({ to, direction }) => {
  const icon = direction === 'left' ? 'chevron_left' : 'chevron_right';

  return (
    <ButtonStyle>
      <InternalLink to={to}>
        <i data-phosphor-icons="true">{icon}</i>
      </InternalLink>
    </ButtonStyle>
  );
};

const ButtonStyle = styled.div`
  height: 100%;
  width: 100%;

  & a {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    &:hover {
      background-color: var(--p-color-background-grey);
    }

    i {
      font-size: 2rem;
    }

    /*
      Remove content that sticks out of its own container.
      Otherwise we get horizontal scrollbars due to the extra height.
    */
    ::after {
      content: none;
    }
  }
`;
